import React, { createContext, useContext } from "react";
import { IHistoryProvider, HistoryProviderOptions } from "./IProvider";
import { useHistoryManager } from "./HistoryManager";

const HistoryManagerContext = createContext<IHistoryProvider | null>(null);

export const HistoryManagerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const historyManager = useHistoryManager(HistoryProviderOptions.CosmosDB);
    return <HistoryManagerContext.Provider value={historyManager}>{children}</HistoryManagerContext.Provider>;
};

export const useHistoryManagerContext = (): IHistoryProvider => {
    const context = useContext(HistoryManagerContext);
    if (!context) {
        throw new Error("useHistoryManagerContext must be used within a HistoryManagerProvider");
    }
    return context;
};
